import { Reveal, ChapterTag } from "./motion";
import { useStore } from "../../context/StoreContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

export const Faq = () => {
  const { config } = useStore();
  const faq = config?.faq || [];
  return (
    <section id="faq" data-testid="faq-section" className="py-16 sm:py-24 lg:py-32 bg-zinc-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <Reveal>
          <ChapterTag num="09" label="Questions" />
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">Frequently asked questions</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-8 space-y-3">
            {faq.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="bg-white rounded-2xl border border-zinc-100 px-6 data-[state=open]:border-brand/30"
              >
                <AccordionTrigger data-testid={`faq-question-${i}`} className="text-left font-display font-semibold text-sm sm:text-base hover:no-underline py-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-answer-${i}`} className="text-sm text-zinc-500 leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
